import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withTheme, Typography, LinearProgress } from '@material-ui/core';
import { Logger, Toastr } from 'data/common';
import { logOutUser } from 'data/user/actions';
import { initialize_app } from './actions';
import environments from '../../environments';

class Splashpage extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        initialize_app: PropTypes.func.isRequired,
        logOutUser: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired
    };
    timer = null;

    state = {
        loading_prct: 0
    };

    componentDidMount() {
        this.timer = setInterval(this.progress, 700);
        this.checkToken();
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    progress = () => {
        const { loading_prct } = this.state;
        if (loading_prct < 100) {
            const diff = Math.random() * ((100 - loading_prct * 1.5) / 10);
            this.setState({ loading_prct: Math.min(loading_prct + diff, 100) });
        }
    };

    _finishAppLoading = (pageToRedirect, keyToRedirect, timeout) => {
        const { profile, history } = this.props;
        const userEnvironments = environments.getEnvironments().filter((route, env) => {
            if (profile.get('admin')) return true;
            return profile.get('environments') && profile.get('environments').indexOf(env) !== -1;
        });
        this.setState(
            {
                loading_prct: 100
            },
            () => {
                setTimeout(() => {
                    if (pageToRedirect && pageToRedirect !== '/menu') {
                        Logger.verbose('Trying to redirect to ' + pageToRedirect);
                        Logger.verbose('Redirect to ' + pageToRedirect);
                        return history.replace(pageToRedirect);
                    }

                    if (userEnvironments.size > 1 || profile.get('admin')) {
                        Logger.verbose('Redirect to /menu');
                        return history.replace('/menu');
                    }
                    let redirectTo = null;
                    if (Array.isArray(userEnvironments.first().path)) {
                        for (let aRoute of userEnvironments.first().path) {
                            if (
                                !redirectTo &&
                                (profile.get('admin') || profile.getIn(['user_rights', userEnvironments.keySeq().first()], []).includes(aRoute.right))
                            )
                                redirectTo = aRoute.path;
                        }
                    } else {
                        redirectTo = userEnvironments.first().path;
                    }
                    Logger.verbose(`Redirect to ${redirectTo}`);
                    return history.replace(redirectTo);
                }, timeout);
            }
        );
    };

    checkToken = () => {
        const { initialize_app, logOutUser } = this.props;
        initialize_app().catch(e => {
            Logger.error(e);
            Toastr.error(Translator.translate('splashpage.initialize.error'));
            logOutUser();
            this._finishAppLoading('/login', '/login', __DEV__ ? 500 : 500);
        });
    };

    render() {
        let { loading_prct } = this.state;
        const { profile, history } = this.props;
        const userEnvironments = environments.getEnvironments().filter((route, env) => {
            if (profile.get('admin')) return true;
            return profile.get('environments') && profile.get('environments').indexOf(env) !== -1;
        });
        if (['/', '/menu', '/menu/'].indexOf(history.location.pathname) !== -1 && !profile.get('admin') && userEnvironments.size === 1) {
            let redirectTo = null;
            if (Array.isArray(userEnvironments.first().path)) {
                for (let aRoute of userEnvironments.first().path) {
                    if (
                        !redirectTo &&
                        (profile.get('admin') || profile.getIn(['user_rights', userEnvironments.keySeq().first()], []).includes(aRoute.right))
                    )
                        redirectTo = aRoute.path;
                }
            } else {
                redirectTo = userEnvironments.first().path;
            }
            Logger.verbose(`Redirect to ${redirectTo}`);
            return <Redirect to={redirectTo} />;
        }

        return (
            <div className="d-flex flex-fill flex-column">
                <div style={{ height: 40 }}>
                    <LinearProgress variant="determinate" color="secondary" value={loading_prct} />
                </div>
                <div className="d-flex flex-fill flex-column align-items-center justify-content-center p-3">
                    <img alt="logoFHE" src={require('../../assets/images/logo_fhe.png')} className="img-fluid animated jackInTheBox" />
                    <Typography className="mt-4 text-center animated zoomIn" variant="h6">
                        {Translator.translate('splashpage.loading_message')}
                    </Typography>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ initialize_app, logOutUser }, dispatch)
    )(withTheme(Splashpage))
);



// WEBPACK FOOTER //
// ./scenes/Splashpage/index.js